module.exports = __webpack_public_path__ + "static/media/honey-nature.91237780.png";